import { Node } from "unist";
import { Parent } from "hast";

// TODO: find a better way of avoiding hydration errors
// this one seem's not to be the best one
function isParent(tree: Node): tree is Parent {
    return "children" in tree;
}
export default function rehypeRemoveNewlines() {
    return (tree: Node) => {
        if (!tree || !isParent(tree)) return;
        for (let i = 0; i < tree.children.length; ) {
            const node = tree.children[i];
            if (node.type === "text" && node.value.match(/^\n+$/)) {
                tree.children.splice(i, 1);
            } else {
                i++;
            }
        }
    };
}
